'use client'
import { Flex, FormControl, FormLabel, Input, useToast, FormErrorMessage, Text, Link, Box, VStack, Heading } from '@chakra-ui/react'
import { useState } from 'react'

import { API_ROUTES, APP_ROUTES } from '@/lib/constants'
import CtaManager from '@/components/molecules/Cta/Manager'

const copy = {
  email: 'Email',
  password: 'Password',
  signIn: 'Registrati',
  placeholderEmail: 'Inserisci la tua email',
  placeholderPassword: 'Inserisci la tua password',
}

const styles = {
  mainWrapper: {
    flexDirection: 'column',
    gap: '.75rem',
    margin: '0 auto',
    alignSelf: 'center',
    paddingInline: {
      base: '1rem',
      md: '2rem',
    },
    width: '100%'
  },
  input: {
    w: '100%',
    borderRadius: '0.75rem',
    border: '1px solid #DFDFDF',
    backgroundColor: '#F2F2F2',
    _placeholder: {
      fontSize: '14px',
      lineHeight: '24px',
    },
    focusBorderColor: '#9107FE',
  },
  formControl: {
    margin: 'unset',
  },
  formLabel: {
    fontWeight: '500',
    lineHeight: '30px',
  },
  cta: {
    width: '100%',
  },
}

const normalizeErrors = (errorsPayload) => {
  return Object.keys(errorsPayload).reduce((acc, key) => {
    const error = errorsPayload[key].join()
    acc[key] = error
    return acc
  }, {})
}

const RegistrationForm = ({ handleSignIn: _handleSignIn = () => {} }) => {
  const initialState = { email: '', password: '' }
  const [credentials, setCredentials] = useState(initialState)
  const [errors, setErrors] = useState({})
  const [registerStatus, setRegisterStatus] = useState('default')
  const toast = useToast()

  const handleCredentialsOnChange = (e) => {
    if (!!errors[e.target.name]) {
      const newErrors = structuredClone(errors)
      delete newErrors[e.target.name]
      setErrors(newErrors)
    }

    setCredentials({ ...credentials, [e.target.name]: e.target.value })
  }

  const onSubmit = async () => {
    setErrors({})

    if (registerStatus === 'sending') return
    setRegisterStatus('sending')

    const {  email, password } = credentials

    try {
      const headers = new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      })

      const response = await fetch(API_ROUTES.INTERNAL_AUTH_REGISTER, {
        method: 'POST',
        headers,
        body: JSON.stringify({ email, password }),
      })

      if (!response.ok) {
        const { message } = await response.json()
        const errorMessages = normalizeErrors(message)
        setErrors(errorMessages)
        throw new Error('Qualcosa è andato storto!')
      }

      setCredentials(initialState)
      setRegisterStatus('registered')
    } catch (error) {
      console.error('Registration Failed:', error)

      toast({
        title: 'Registration Failed',
        description: error.message,
        status: 'error',
        duration: 1500
      })
      setRegisterStatus('default')
    }
  }

  return (
    <Flex {...styles.mainWrapper}>
      {
        registerStatus === 'registered'
          ? (
            <Box className='confirm-message'>
              <VStack>
                <Heading as="h3" style={{ textAlign: 'center', marginBottom: '32px' }}>Registrazione completata!</Heading>
                <Text style={{ textAlign: 'center' }}>Verrai avvisato via email quando il tuo account sarà attivato.</Text>
              </VStack>
            </Box>
          )
          : (
            <form style={{
              display: 'grid',
              gap: 20,
              width: '100%',
            }}>
              <FormControl {...styles.formControl} isRequired isInvalid={!!errors.email}>
                <FormLabel {...styles.formLabel}>{copy.email}</FormLabel>
                <Input
                  type="email"
                  name={'email'}
                  value={credentials.email}
                  onChange={handleCredentialsOnChange}
                  placeholder={copy.placeholderEmail}
                  {...styles.input}
                />
                <FormErrorMessage>{errors.email}</FormErrorMessage>
              </FormControl>

              <FormControl {...styles.formControl} isRequired isInvalid={!!errors.password}>
                <FormLabel {...styles.formLabel}>{copy.password}</FormLabel>
                <Input
                  type="password"
                  name={'password'}
                  value={credentials.password}
                  onChange={handleCredentialsOnChange}
                  placeholder={copy.placeholderPassword}
                  {...styles.input}
                />
                <FormErrorMessage>{errors.password}</FormErrorMessage>
              </FormControl>

              <Text fontSize='sm'>Se hai già un account vai alla <Link textDecoration={'underline'} href={APP_ROUTES.AUTH_SIGN_IN}>Login</Link></Text>

              <CtaManager
                type="button"
                onClick={onSubmit}
                primary
                {...styles.cta}
                isDisabled={registerStatus === 'sending'}
              >
                {copy.signIn}
              </CtaManager>
            </form>
          )
      }
    </Flex>
  )
}

export default RegistrationForm
